/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbClasseApprenantGridDto } from './FcbClasseApprenantGridDto';
import {
    FcbClasseApprenantGridDtoFromJSON,
    FcbClasseApprenantGridDtoFromJSONTyped,
    FcbClasseApprenantGridDtoToJSON,
} from './FcbClasseApprenantGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbClasseApprenantGridDtoPaginatedResults
 */
export interface FcbClasseApprenantGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbClasseApprenantGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbClasseApprenantGridDto>}
     * @memberof FcbClasseApprenantGridDtoPaginatedResults
     */
    results?: Array<FcbClasseApprenantGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbClasseApprenantGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbClasseApprenantGridDtoPaginatedResults interface.
 */
export function instanceOfFcbClasseApprenantGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbClasseApprenantGridDtoPaginatedResultsFromJSON(json: any): FcbClasseApprenantGridDtoPaginatedResults {
    return FcbClasseApprenantGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbClasseApprenantGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbClasseApprenantGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbClasseApprenantGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbClasseApprenantGridDtoPaginatedResultsToJSON(value?: FcbClasseApprenantGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbClasseApprenantGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

